import { parseNumeric } from './numberUtils';
import { normalizeLabel } from './labels';

type OptionLike = {
  label?: string;
  value: unknown;
};

/**
 * Resolves and normalizes an option label from a raw value.
 */
export function resolveOptionLabel(value: unknown, options: OptionLike[]): string {
  if (value == null || value === '') {
    return '';
  }

  const parsed = parseNumeric(value);
  if (parsed == null) {
    return '';
  }

  const label = options.find((option) => parseNumeric(option.value) === parsed)?.label;
  return normalizeLabel(label);
}
